/** How long a Club trial has left, in the largest whole unit a player reads at a glance. Pure. */
export function trialLeft(ms: number): { unit: "days" | "hours" | "minutes"; count: number } {
  const minutes = Math.max(1, Math.ceil(ms / 60_000));
  if (minutes < 60) return { unit: "minutes", count: minutes };
  const hours = Math.ceil(minutes / 60);
  if (hours < 24) return { unit: "hours", count: hours };
  return { unit: "days", count: Math.ceil(hours / 24) };
}
